import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import LabBottomNavigation from "../../components/LabBottomNavigation";
import ListEmpty from "../../components/ListEmpty";
import Loading from "../../components/Loading";
import MobileBottomPagination from "../../layouts/components/MobileBottomPagination";
import { getAllOrders } from "../../redux/actions/orders";
import { getVendorType } from "../../services/auth";
import FilterOrdersComponentMobile from "./components/FilterOrdersComponentMobile";
import PharmacyOrderItem from "./components/PharmacyOrderItem";
import HomeCareOrdersListExcel from "./HomeCareOrdersListExcel";

const OrdersMobile = (props) => {
  const dispatch = useDispatch();
  const vendor_type = getVendorType();
  const list_empty_message = "موردی جهت نمایش وجود ندارد";
  const { all_orders_success, all_orders_waiting } = useSelector(
    (state) => state.orders
  );
  const [orders, setOrders] = useState({
    orders: [],
    total: 0,
    current: 1,
    per_page: 10,
  });
  const [query, setQuery] = useState({
    page: 1,
    per_page: 10,
  });
  const [newOrdersParse, setNewOrdersParse] = useState([]);
  const [newOrdersExport, setNewOrdersExport] = useState([]);
  useEffect(() => {
    dispatch(getAllOrders(query));
  }, [query]);

  useEffect(() => {
    if (all_orders_success.result && all_orders_success.result === "SUCCESS") {
      setOrders({
        orders: all_orders_success.data.orders,
        total: all_orders_success.data.total,
        current: all_orders_success.data.page,
        per_page: all_orders_success.data.per_page,
      });
    }
  }, [all_orders_success]);

  const parseOrdersForTable = (orders) => {
    let ordersParse = [];
    orders.orders.map((order, index) => {
      if (
        order.meta_data !== undefined &&
        order.meta_data !== null &&
        Object.keys(order.meta_data).length !== 0
      ) {
        const metaData = order.meta_data;
        const newObj = JSON.parse(metaData);
        const emptySamplerName = {
          key: "sampler_name",
          title: "نام پزشک/پرستار",
          value: "-",
        };
        const newMetaData =
          newObj.sampler_name !== null && newObj.sampler_name !== undefined
            ? { ...newObj }
            : { ...newObj, sampler_name: emptySamplerName };
        const newOrder = { ...order, meta_data: newMetaData };
        ordersParse.push(newOrder);
      } else {
        ordersParse.push(order);
      }
    });
    setNewOrdersParse(ordersParse);
    // dataForExport()
  };
  // const dataForExport = () => {
  //     const newOrderArrayExport = []
  //     console.log("dsd",newOrdersParse)
  //         newOrdersParse.map((order,index) => {
  //             const samplerName = (order.meta_data.sampler_name !== null && order.meta_data.sampler_name !== undefined) ?  order.meta_data.sampler_name.value : '-'
  //             const newObjExport = {
  //                 ...order,
  //                 service_title: order.prices.length !== 0 ? order.prices[0].title : '-',
  //                 service_count: order.prices.length !== 0 ? order.prices[0].count : '-',
  //                 service_worker: samplerName
  //             }
  //             newOrderArrayExport.push(newObjExport)
  //         })
  //         setNewOrdersExport(newOrderArrayExport)
  //         console.log("mew", newOrderArrayExport)
  // }
  const checkOrdersExport = () => {
    const newOrderArrayExport = [];
    if (newOrdersParse.length !== 0) {
      newOrdersParse.map((order, index) => {
        const samplerName =
          order.meta_data.sampler_name !== null &&
          order.meta_data.sampler_name !== undefined
            ? order.meta_data.sampler_name.value
            : "-";
        const newObjExport = {
          ...order,
          service_title:
            order.prices.length !== 0 ? order.prices[0].title : "-",
          service_count:
            order.prices.length !== 0 ? order.prices[0].count : "-",
          service_worker: samplerName,
        };
        newOrderArrayExport.push(newObjExport);
      });
      setNewOrdersExport(newOrderArrayExport);
      return newOrderArrayExport;
    }
  };

  useEffect(() => {
    if (vendor_type !== "DRUG") {
      if (
        orders.orders !== undefined &&
        orders.orders !== null &&
        orders.orders.length !== 0
      ) {
        parseOrdersForTable(orders);
      }
    }
  }, [orders]);

  return (
    <>
      {vendor_type !== "DRUG" ? <LabBottomNavigation {...props} /> : null}
      <div className="all-orders-list-mobile">
        {vendor_type !== "DRUG" && (
          <FilterOrdersComponentMobile
            search={
              all_orders_success.data === undefined
                ? ""
                : all_orders_success.data.query
            }
            page={
              all_orders_success.data === undefined
                ? ""
                : all_orders_success.data.page
            }
            perPage={
              all_orders_success.data === undefined
                ? ""
                : all_orders_success.data.per_page
            }
          />
        )}
        {all_orders_waiting ? (
          <Loading />
        ) : orders.orders.length === 0 ? (
          <ListEmpty message={list_empty_message} />
        ) : vendor_type !== "DRUG" ? (
          newOrdersParse.map((order, index) => {
            return <PharmacyOrderItem {...order} key={order.id} />;
          })
        ) : (
          orders.orders.map((order, index) => {
            return <PharmacyOrderItem {...order} key={order.id} />;
          })
        )}
        {vendor_type !== "DRUG"
          ? !all_orders_waiting &&
            orders.orders.length !== 0 && (
              <div className="actions-report-lab-mobile">
                <HomeCareOrdersListExcel orders={checkOrdersExport} />
                <MobileBottomPagination
                  total={orders.total}
                  current={orders.current}
                  per_page={orders.per_page}
                  className="mobile-items-lab-pagination"
                  api={getAllOrders}
                />
              </div>
            )
          : !all_orders_waiting &&
            orders.orders.length !== 0 && (
              <MobileBottomPagination
                total={orders.total}
                current={orders.current}
                per_page={orders.per_page}
                api={getAllOrders}
              />
            )}
      </div>
    </>
  );
};

export default OrdersMobile;
